const customFetch = async (url, configs) => {
    try {
        var controller = new AbortController();
        var signal = controller.signal;
        configs = { ...configs, signal };
        const response = await fetch(url, configs);
        return response;
    } catch (e) {
        throw e;
    }
};

export default customFetch